import { useDrawer } from '~/shared/ui/Drawer'
import { Arrow45Icon, InfoSmallOutlinedIcon } from '~/shared/ui/icons'
import { DailyDebitScheduleDrawer } from './Content'
import { InfoIconWrapper, Title, TitleWrapper, Wrapper } from './styled'

export function DailyDebitSchedule() {
  const [isDrawerShow, openDrawer, closeDrawer] = useDrawer()
  return (
    <>
      <Wrapper onClick={openDrawer}>
        <TitleWrapper>
          <InfoIconWrapper>
            <InfoSmallOutlinedIcon />
          </InfoIconWrapper>
          <Title>Подробнее</Title>
        </TitleWrapper>
        <Arrow45Icon />
      </Wrapper>

      <DailyDebitScheduleDrawer isShow={isDrawerShow} onClose={closeDrawer} />
    </>
  )
}
